<div class="pedido-item-desconto-maximo-excedido-table-view">
    <ng-template [ngIf]="config?.isLoading">
        <i class='fas fa-spinner fa-pulse'></i> Carregando
    </ng-template>

    <ng-template [ngIf]="!config?.isLoading && pedidosItens">
        <pedido-item-desconto-maximo-excedido-table
            [idTable]="idTable"
            [pedidosItens]="pedidosItens">
        </pedido-item-desconto-maximo-excedido-table>
    </ng-template>    
</div>